import { render, staticRenderFns } from "./MatchProductsModal.vue?vue&type=template&id=6df524d0&scoped=true"
import script from "./MatchProductsModal.vue?vue&type=script&lang=js"
export * from "./MatchProductsModal.vue?vue&type=script&lang=js"
import style0 from "./MatchProductsModal.vue?vue&type=style&index=0&id=6df524d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df524d0",
  null
  
)

export default component.exports